import createDocumentResource from 'src/actions/shared/createDocumentResource';
import Routing from 'src/models/Routing/Routing';

const routingResource = createDocumentResource<Routing>({
  name: 'routing',
  endpoint: 'v1/orgs/:orgId/configuration/messaging',
});

export default routingResource;
